<template>
  <div class="layout-list-two-columns-no-fixed content-wrapper bg-white dark:bg-darkblue-900 flex flex-col w-full relative">
    <slot name="header" />
    <main ref="main" class="content flex flex-col flex-auto overflow-y-auto lg:overflow-y-hidden w-full">
      <div
        :class="{'lg:max-w-twocol ':!toEdge}" :style="{ '--left-height': mainHeight }"
        class="column-container w-full flex flex-col lg:flex-row lg:mr-auto flex-grow">
        <div class="left-col w-full relative overflow-y-hidden lg:overflow-y-auto lg:h-[var(--left-height)]">
          <main class="content h-full flex flex-col flex-auto">
            <div class="table-tools px-4 lg:px-10 w-full sticky top-0 bg-white dark:bg-darkblue-900">
              <div class="flex flex-col lg:flex-row justify-between items-center space-y-3 lg:space-y-0">
                <slot name="table-core" />
              </div>
              <slot name="table-tags" />
            </div>
            <div :class="{ 'table-actions-visible': tableTools }" class="w-full overflow-hidden flex-grow table-kendo">
              <!-- pb-11 lg:pb-15 <div class="w-full lg:px-9"> aqui estaba antes tab-component</div> -->
              <slot name="table-component" />
            </div>
          </main>
        </div>
        <div class="right-col w-full relative overflow-y-hidden lg:overflow-y-auto lg:h-[var(--left-height)]">
          <slot name="RightCol"/>
        </div>
      </div>
    </main>
    <slot name="layout-extend" />
  </div>
</template>
<script>

export default {
  name: 'layout-list-two-columns-no-fixed',
  components: {
  },
  props: {
    toEdge: {
      type: Boolean,
      default: false
    },
    tableTools: {
      type: Boolean,
      default: false
    },
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mainHeight: 'auto',
      resizeObserver: null
    }
  },
  mounted () {
    const mainElement = this.$refs.main
    if (mainElement) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateMainHeight()
      })
      this.resizeObserver.observe(mainElement)
    }
  },
  methods: {
    updateMainHeight: function () {
      const mainElement = this.$refs.main
      if (mainElement) {
        this.mainHeight = getComputedStyle(mainElement).height
      }
    }
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
}
</script>
<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  @include breakpoint(lg) {
    width: calc(100% - 18.125rem);
  }
}

.aside-is-collapsed {
  .content-wrapper {
    @include breakpoint(lg) {
      width: calc(100% - 4.5rem);
    }
  }
}


</style>
<style>
@property --left-height {
  syntax: "<length-percentage>|auto";
  inherits: true;
  initial-value: auto;
}
@media (width < 1300px){
  .column-container{
    flex-direction: column;
  }
}
</style>
